var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actions.length > 0) ? _vm._l((_vm.actions), function(action, index) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-action-' + action.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light",
      class: (action.limit_contravention !== null ? 'bg-danger-light' : '')
    }, [(action.internal) ? _c('div', {
      staticClass: "p-0 text-secondary"
    }, [_vm._v("\n                    " + _vm._s(action.operation.code) + " "), _c('i', {
      staticClass: "fa fa-hand-spock-o text-danger",
      attrs: {
        "title": "interní výkon",
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(action.operation.name) + "\n                ")]) : _c('div', {
      staticClass: "p-0"
    }, [(action.limit_contravention !== null) ? [_c('button', {
      staticClass: "btn btn-sm btn-outline-danger mr-sm-2",
      attrs: {
        "title": "porušení pravidel vykazování",
        "type": "button",
        "id": "contraventionActionButton"
      },
      on: {
        "click": function($event) {
          _vm.showModalActionContravention(action.limit_contravention)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })])] : _vm._e(), _vm._v("\n                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                    "), _c('span', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "fa fa-diamond",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                        " + _vm._s(action.operation.point_total) + "\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-outline-primary mr-sm-2",
      attrs: {
        "type": "button",
        "id": "infoActionButton",
        "data-testid": 'visit-action-info-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.showModalOperationInfo(action.operation)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })]), _vm._v(" "), (action.operation.zulp === true && _vm.openedAddZulpActionId === action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zulp-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZulpActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    }), _vm._v(" ZULP")]) : _vm._e(), _vm._v(" "), (action.operation.zulp === true && _vm.openedAddZulpActionId !== action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-success",
      attrs: {
        "data-testid": 'visit-zulp-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZulpActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" ZULP")]) : _vm._e(), _vm._v(" "), (action.operation.zum === true && _vm.openedAddZumActionId === action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zum-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZumActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    }), _vm._v(" ZUM")]) : _vm._e(), _vm._v(" "), (action.operation.zum === true && _vm.openedAddZumActionId !== action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-success",
      attrs: {
        "data-testid": 'visit-zum-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZumActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" ZUM")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [_c('i', [_vm._v(_vm._s(action.note))])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(action.zulp.length < 1 && action.zum.length < 1) ? [(!_vm.actionsPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-action-delete-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.actionsPending ? null : _vm.removeAction(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)]), _vm._v(" "), _c('list-zulp', {
      attrs: {
        "zulp": action.zulp
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    }), _vm._v(" "), (action.id === _vm.openedAddZulpActionId) ? [_c('add-zulp', {
      attrs: {
        "action-id": action.id
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    })] : _vm._e(), _vm._v(" "), _c('list-zum', {
      attrs: {
        "zum": action.zum
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    }), _vm._v(" "), (action.id === _vm.openedAddZumActionId) ? [_c('add-zum', {
      attrs: {
        "operation": action.operation.code,
        "action-id": action.id
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    })] : _vm._e()], 2)
  }) : _vm._e(), _vm._v(" "), _c('action-contravention', {
    attrs: {
      "limit-contravention": _vm.limitContravention
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010c1387","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListActions.vue
// module id = 528
// module chunks = 0